import type { ComponentProps } from "react"
import cn from "@/v2-ui/utils/utils.cn"
import Badge from "@/v2-backoffice-client/components/badge"
import { formatMcpClient } from "@/v2-backoffice-client/usage/mcp/usage.mcp.constants"

export type UsageMcpClientChipsProps = ComponentProps<"span"> & {
  /** Client codes as the servers stamp them, most calls first. */
  clients: string[]
  /** Chips shown before "+N". */
  limit?: number
}

// The AI clients a customer or person connects from, as a short row of
// chips with "+N" past the limit — one line in a table cell, never a
// column of wrapped names. Hover shows the full list.
function UsageMcpClientChips(props: UsageMcpClientChipsProps) {
  const { clients, limit = 2, className, ...spanProps } = props
  if (clients.length === 0) {
    return <span className="text-muted-foreground">—</span>
  }
  const visible = clients.slice(0, limit)
  const hidden = clients.length - visible.length
  return (
    <span
      className={cn("usage-report-chips whitespace-nowrap", className)}
      title={clients.map(formatMcpClient).join(", ")}
      {...spanProps}
    >
      {visible.map((client) => (
        <Badge key={client} variant="outline" size="xs" className="font-normal">
          {formatMcpClient(client)}
        </Badge>
      ))}
      {hidden > 0 && (
        <span className="text-[11px] text-muted-foreground">+{hidden}</span>
      )}
    </span>
  )
}

export default UsageMcpClientChips
